/**
 * Shift Settings — Domain API Module
 *
 * Wraps the shared V2 API client for all data operations on the
 * ShiftSettingsPage (24-hour shift hour assignments).
 *
 * Data table: core_shift_hours (PK: shift_hour_id)
 *
 * shift_name values:  "Day" | "Evening" | "Night"
 * hour_of_day:        0–23
 */

import { apiFetch, apiSave, apiTransaction } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// READ
// ---------------------------------------------------------------------------

/** Fetch all 24 shift hour records for a campus. */
export function fetchShiftHours(campusId) {
    return apiFetch({
        pKey: 'campus_id',
        pVal: campusId,
        table: 'core_shift_hours',
        procedure: 'fetchbyparameter',
        reqType: 'direct',
    });
}

// ---------------------------------------------------------------------------
// WRITE
// ---------------------------------------------------------------------------

/**
 * Create the initial 24 shift hour records (backend transaction).
 * All hours default to "Day" on the server side.
 */
export function createShiftDefaults(campusId, userId, clientId) {
    return apiTransaction({
        transType: 'shift_add',
        payload: [],
        campusId,
        userId,
        clientId,
    });
}

/**
 * Save all 24 shift assignments in a single batch update.
 *
 * @param {Array<{shift_hour_id: number, shift_name: string}>} payload
 */
export function saveShiftHours(payload, { campusId, userId, clientId }) {
    return apiSave({
        table: 'core_shift_hours',
        payload,
        pKey: 'shift_hour_id',
        condition: 'primary',
        campusId,
        userId,
        clientId,
        method: 'POST',
    });
}
